module.exports = __webpack_public_path__ + "bgvideo.mp4";